var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var getIcon = function (icon, size, fill, label) {
    if (label === void 0) { label = ''; }
    var fillEncoded = fill.replace('#', '%23');
    var dataUri = icon.replace('XXXXX', fillEncoded);
    return {
        label: label,
        display: 'inline-block',
        backgroundSize: 'contain',
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundImage: "url(\"".concat(dataUri, "\")"),
        width: size,
        height: size,
    };
};
var icon = {
    dragHandle: "data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='128px' height='128px' viewBox='0 0 128 128' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3E一 Parts / Bold / Actions – drag%3C/title%3E%3Cg id='一-Parts-/-Bold-/-Actions-–-drag' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cpath d='M2,102 L28,102 L28,128 L2,128 Z M2,51 L28,51 L28,77 L2,77 Z M2,0 L28,0 L28,26 L2,26 Z M51,102 L77,102 L77,128 L51,128 Z M51,51 L77,51 L77,77 L51,77 Z M51,0 L77,0 L77,26 L51,26 Z M100,102 L126,102 L126,128 L100,128 Z M100,51 L126,51 L126,77 L100,77 Z M100,0 L126,0 L126,26 L100,26 Z' id='Style' fill='XXXXX' fill-rule='nonzero'%3E%3C/path%3E%3C/g%3E%3C/svg%3E",
    collapse: "data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='128px' height='128px' viewBox='0 0 128 128' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3E一 Parts / Bold / Navigation – chevron-up%3C/title%3E%3Cg id='一-Parts-/-Bold-/-Navigation-–-chevron-up' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cpath d='M63.8131271,47.8009338 L114.720598,98.7084044 C115.509165,99.496972 116.770313,99.495551 117.549042,98.716822 L126.042724,90.2231406 C126.820221,89.4456438 126.817684,88.1780738 126.034306,87.3946959 L65.2315583,26.591948 C64.8358715,26.1962612 64.3211974,26 63.8081896,26 C63.3027904,26.0023777 62.7877855,26.1988584 62.3946959,26.591948 L1.59194796,87.3946959 C0.803380361,88.1832635 0.80480135,89.4444117 1.58353033,90.2231406 L10.0772117,98.716822 C10.8547085,99.4943188 12.1222786,99.4917823 12.9056565,98.7084044 L63.8131271,47.8009338 L63.8131271,47.8009338 Z' id='Style' fill='XXXXX'%3E%3C/path%3E%3C/g%3E%3C/svg%3E",
    expand: "data:image/svg+xml,%3C%3Fxml version='1.0' encoding='UTF-8'%3F%3E%3Csvg width='128px' height='128px' viewBox='0 0 128 128' version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Ctitle%3E一 Parts / Bold / Navigation – chevron-down%3C/title%3E%3Cg id='一-Parts-/-Bold-/-Navigation-–-chevron-down' stroke='none' stroke-width='1' fill='none' fill-rule='evenodd'%3E%3Cpath d='M63.8131271,81.4994186 L114.720598,30.591948 C115.509165,29.8033804 116.770313,29.8048014 117.549042,30.5835303 L126.042724,39.0772117 C126.820221,39.8547085 126.817684,41.1222786 126.034306,41.9056565 L65.2315583,102.708404 C64.8358715,103.104091 64.3211974,103.300352 63.8081896,103.300352 C63.3027904,103.297975 62.7877855,103.101494 62.3946959,102.708404 L1.59194796,41.9056565 C0.803380361,41.1170889 0.80480135,39.8559407 1.58353033,39.0772117 L10.0772117,30.5835303 C10.8547085,29.8060335 12.1222786,29.8085701 12.9056565,30.591948 L63.8131271,81.4994186 L63.8131271,81.4994186 Z' id='Style' fill='XXXXX'%3E%3C/path%3E%3C/g%3E%3C/svg%3E",
};
export var sortable = {
    display: 'table',
    width: '100%',
    '&.pcty-sortable-disabled': {
        '.pcty-sortable-handle': __assign(__assign({}, getIcon(icon.dragHandle, 16, '#a6a6a6')), { cursor: 'not-allowed' }),
    },
};
export var ghost = {
    filter: 'grayscale(100%)',
    opacity: 0.25,
};
export var handle = __assign(__assign({}, getIcon(icon.dragHandle, 16, '#347ABE')), { cursor: 'grab', position: 'relative', zIndex: 1 });
export var item = {
    background: '#ffffff',
    color: '#111E28',
    display: 'table-row',
    lineHeight: "".concat(16, "px"),
    width: '100%',
    '&.pcty-sortable-item-disabled': {
        color: "".concat('#cccccc', " !important"),
        '.pcty-sortable-handle': __assign(__assign({}, getIcon(icon.dragHandle, 16, '#a6a6a6')), { cursor: 'not-allowed' }),
    },
};
export var section = {
    display: 'table-row-group',
    width: '100%',
    '&.pcty-sortable-section-disabled': {
        '& .pcty-sortable-section-title': {
            color: "".concat('#cccccc', " !important"),
        },
        '.pcty-sortable-handle': __assign(__assign({}, getIcon(icon.dragHandle, 16, '#a6a6a6')), { cursor: 'not-allowed' }),
    },
    '.pcty-sortable-item:not(.pcty-sortable-section-title)': {
        '.pcty-sortable-column': {
            '.pcty-sortable-handle': {
                display: 'none',
            },
            '.pcty-sortable-column-inner': {
                '.pcty-sortable-column-inner-column': {
                    '&:first-of-type': {
                        width: 24,
                    },
                },
                '.pcty-sortable-handle': {
                    display: 'block',
                },
            },
        },
    },
};
export var sectionTitle = __assign(__assign({}, item), { background: '#EFF3F6', '.pcty-sortable-column': {
        fontWeight: 'bold',
    } });
export var header = __assign(__assign({}, item), { color: '#666666', fontWeight: 'bold' });
export var column = {
    borderBottom: '1px solid #C9CFD4',
    display: 'table-cell',
    padding: 8,
    verticalAlign: 'middle',
    '&.pcty-sortable-border-top': {
        borderTop: '1px solid #C9CFD4',
    },
    '&.pcty-sortable-border-none': {
        border: 'none',
    },
    '&:first-of-type': {
        borderRadius: '0 0 0 0',
        paddingRight: 0,
        width: 16,
    },
    '&:last-of-type': {
        borderRadius: '0 0 0 0',
    },
    '.pcty-sortable-column-inner': {
        display: 'table',
        width: '100%',
        '.pcty-sortable-column-inner-column': {
            display: 'table-cell',
            verticalAlign: 'middle',
            '&:first-of-type': {
                width: 0,
            },
        },
        '.pcty-sortable-handle': {
            display: 'none',
        },
    },
};
export var drag = {
    opacity: '1 !important',
    '&.pcty-sortable-section': {
        borderRadius: 8,
        boxShadow: '0 4px 12px rgba(75, 88, 99, 0.5)',
        display: 'table',
        width: '100%',
        '.pcty-sortable-section-title': {
            '.pcty-sortable-column': {
                ':first-of-type': {
                    borderRadius: '8px 0 0 0',
                },
                ':last-of-type': {
                    borderRadius: '0 8px 0 0',
                },
            },
            backgroundColor: '#347ABE',
            color: '#ffffff',
            '.pcty-sortable-handle': __assign({}, getIcon(icon.dragHandle, 16, '#ffffff')),
        },
        '.pcty-sortable-item': {
            ':last-of-type': {
                '.pcty-sortable-column': {
                    ':first-of-type': {
                        borderRadius: '0 0 0 8px',
                    },
                    ':last-of-type': {
                        borderRadius: '0 0 8px 0',
                    },
                },
            },
        },
        '.pcty-sortable-item:not(.pcty-sortable-section-title)': {
            backgroundColor: '#FFFFFF',
            display: 'table-row',
            width: '100%',
        },
    },
    '&:not(.pcty-sortable-section)': {
        borderRadius: 8,
        boxShadow: '0 4px 12px rgba(75, 88, 99, 0.5)',
        '&.pcty-sortable-item': {
            backgroundColor: '#347ABE',
            color: '#ffffff',
            display: 'table',
            width: '100%',
            '.pcty-sortable-handle': __assign({}, getIcon(icon.dragHandle, 16, '#ffffff')),
            '.pcty-sortable-column-inner': {
                '.pcty-sortable-handle': {
                    display: 'none',
                },
            },
        },
    },
};
export var sectionEmpty = {
    display: 'table-row-group',
    width: '100%',
};
export var staticSortable = {
    borderBottom: "1px solid ".concat('#cccccc'),
    borderCollapse: 'collapse',
    boxSizing: 'border-box',
    display: 'table',
    margin: 0,
    padding: 0,
    width: '100%',
};
export var staticGroup = {
    display: 'table',
    width: '100%',
};
export var staticItem = {
    background: '#ffffff',
    color: '#111E28',
    display: 'table-row',
    lineHeight: "".concat(16, "px"),
    width: '100%',
};
export var staticDivider = __assign(__assign({}, staticItem), { cursor: 'default', fontWeight: 'bold', position: 'relative', width: '100%', '.pcty-list-column': {
        cursor: 'pointer',
        border: 'none',
        backgroundColor: '#EFF3F6',
        borderTop: '1px solid #C9CFD4',
        '&:last-of-type': {
            position: 'relative',
            '&:after': {
                content: '""',
                lineHeight: "".concat(32, "px"),
                position: 'absolute',
                top: 8,
                right: 12,
            },
        },
    } });
export var staticDividerInactive = {
    '&:last-of-type': {
        '&:after': __assign({}, getIcon(icon.expand, 16, '#347ABE')),
    },
};
export var staticDividerActive = {
    '&:last-of-type': {
        '&:after': __assign({}, getIcon(icon.collapse, 16, '#347ABE')),
    },
};
export var staticColumn = {
    borderTop: '1px solid #C9CFD4',
    display: 'table-cell',
    padding: 8,
    verticalAlign: 'middle',
};
export var staticItemChild = {
    '.pcty-list-column': {
        '&:first-of-type': {
            paddingLeft: 32,
        },
    },
};
